import React from 'react';

interface MetaLabelProps {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

/**
 * Nobel Aesthetic Component: Meta Label
 * Usage: Column headers, tags, timestamps, gate numbers
 * Style: text-xs font-bold tracking-[0.2em] uppercase text-stone-500
 */
export const MetaLabel: React.FC<MetaLabelProps> = ({ children, className = '', style }) => {
    return (
        <span className={`meta-label ${className}`} style={style}>
            {children}
        </span>
    );
};
